// vue-notification рендерит text через v-html, поэтому серверные строки (эхо пользовательского
// ввода в ошибках валидации) экранируем перед показом.
export default function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value == null ? '' : String(value);
  return div.innerHTML;
}
